import React from 'react'
import STPPreventiveCard from './STPPreventiveCard'
import { useNavigate } from 'react-router-dom'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'
import { useAuthState } from '../../../../../Helper/Context'


export default function STPPreventiveCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, RoleID } = userDetails.user

    const STPPreventiveCardNavigate = (name, Quality) => {
        if (name === "Sewerage Quality") {
            navigate(`/stppreventiveseweragequalitydata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}&Quality=${Quality}`)
        } else if (name === "Machinery Operation") {
            navigate(`/stppreventivemachineryoperationdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Energy Consumption") {
            navigate(`/stppreventiveenergyconsumptiondata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Machinery Checklist") {
            navigate(`/stppreventivemachinerychecklistdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "MPCB Test") {
            navigate(`/stppreventivempcbtestdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "House Keeping") {
            navigate(`/stppreventivehousekeepingdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Energy Audit") {
            navigate(`/stppreventiveenergyauditdata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Breakdown Maintenance") {
            navigate(`/stpbreakdownmaintainancedata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Preventive Maintenance") {
            navigate(`/stppreventivemaintainancedata?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${Ward?.ID}&WLable=${Ward?.Label}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }

    const navigate = useNavigate()

    const PreventivePiedata = {
        labels: ["Sewerage Quality - A", "Sewerage Quality - B", "Machinery Operation", "Energy Consumption", "Machinery Checklist",
            "MPCB Test", "House Keeping", "Energy Audit",
        ],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    Countdata && Countdata?.SewerageQuality_ATotalCount,
                    Countdata && Countdata?.SewerageQuality_BTotalCount,
                    Countdata && Countdata?.MachineryOperationTotalCount,
                    Countdata && Countdata?.EnergyConsumptionTotalCount,
                    Countdata && Countdata?.MachineryCheckListTotalCount,
                    Countdata && Countdata?.MPCBTestTotalCount,
                    Countdata && Countdata?.HouseKeppingTotalCount,
                    Countdata && Countdata?.EnergyAuditTotalCount,
                    // 10,20,30,14,10,52,45,
                ],
                backgroundColor: [
                    "#df356d",
                    "#293D7C",
                    "#606583",
                    "#51dcd2",
                    '#C20CBF',
                    "#5479c2",
                    "#FFC33D",
                    "#154779",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row'>
            <div className="col-12 col-lg-8">
                <div className="row ps-lg-3">
                    <div className="col-12">
                        <h5 className="ps-2 pb-2">Preventive Water</h5>
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Sewerage Quality"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/high-quality.png'
                            count={Countdata.SewerageQuality_ATotalCount ? Countdata.SewerageQuality_ATotalCount : '0'}
                            countB={Countdata.SewerageQuality_BTotalCount ? Countdata.SewerageQuality_BTotalCount : '0'}
                            // navLink='/preventivepumping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />
                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Machinery Operation"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/engineering.png'
                            count={Countdata.MachineryOperationTotalCount ? Countdata.MachineryOperationTotalCount : '0'}
                            // navLink='/preventivecustomer'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>
                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Energy Consumption"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/energy-consumption.png'
                            count={Countdata.EnergyConsumptionTotalCount ? Countdata.EnergyConsumptionTotalCount : '0'}
                            // navLink='/preventivesecurity'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Machinery Checklist"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/testing.png'
                            count={Countdata.MachineryCheckListTotalCount ? Countdata.MachineryCheckListTotalCount : '0'}
                            // navLink='/preventiveenergyaudit'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="MPCB Test"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/test.png'
                            count={Countdata.MPCBTestTotalCount ? Countdata.MPCBTestTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="House Keeping"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/house-cleaning.png'
                            count={Countdata.HouseKeppingTotalCount ? Countdata.HouseKeppingTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Energy Audit"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/audit.png'
                            count={Countdata.EnergyAuditTotalCount ? Countdata.EnergyAuditTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                </div>

                <div className='row mt-lg-2 ps-lg-3'>
                    <div className="col-12">
                        <h5 className="ps-2 pb-2">Maintainance</h5>
                    </div>
                    <div className="col-12 col-lg-6 col-md-6 mb-2 ">
                        <STPPreventiveCard
                            title="Breakdown Maintenance"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/tool-box.png'
                            count={Countdata.BreakdownMaintenanceTotalCount ? Countdata.BreakdownMaintenanceTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>

                    <div className="col-12 col-lg-6 col-md-6 mb-2">
                        <STPPreventiveCard
                            title="Preventive Maintenance"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/medical-insurance.png'
                            count={Countdata.PreventiveMaintenanceTotalCount ? Countdata.PreventiveMaintenanceTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            STPPreventiveCardNavigate={STPPreventiveCardNavigate}
                        />

                    </div>
                </div>
            </div>
            <div className="col-12 col-lg-4 pt-lg-5 mt-lg-5">
                {/* <div className="row">
                    <div className="col-12">
                        <div className=" px-3 mt-3 pb-2 bg-white rounded rounded-3">
                            <div className="row d-flex justify-content-center align-items-center"> */}

                {
                    (Countdata?.SewerageQuality_ATotalCount != 0) || (Countdata?.SewerageQuality_BTotalCount != 0) ||
                        (Countdata?.MachineryOperationTotalCount != 0) || (Countdata?.EnergyConsumptionTotalCount != 0) ||
                        (Countdata?.MachineryCheckListTotalCount != 0) || (Countdata?.MPCBTestTotalCount != 0) ||
                        (Countdata?.HouseKeppingTotalCount != 0) || (Countdata?.EnergyAuditTotalCount != 0) ?
                        <Pie
                            height={210}
                            // width={100}
                            options={Pieoptions}
                            data={PreventivePiedata}
                        />
                        :
                        <div className='text-danger text-center pt-lg-5 fw-bolder'>
                            No Data Found
                        </div>
                }
                {/* </div>

                        </div>
                    </div>
                </div> */}
            </div>
        </div>
    )

}

